import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboardList } from '@fortawesome/pro-regular-svg-icons/faClipboardList'

export const defaultTranslations = {
    pluginName: 'Form',
    pluginDescription: 'Insert a form.',
}

export const defaultSettings = {
    defaultText: '<p>Enter text here.</p>',

    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faClipboardList} size="3x" />,
}
